import store from "@/store";
import emojiRender from '_lib/emoji/EmojiRender'
import { PARSE_LINK_TYPE } from '@/common/constants/IM.ts'
// 获取字符串首个字符，非中文返回两个字符
export function getFirstStr(name) {
  if (!name) {
    return name;
  }
  const letters = Array.from(name);
  // 中文或者长度为1则返回第一个字符
  if (
    letters.length == 1 ||
    /[\u4e00-\u9fa5]/.test(letters[0]) ||
    /[\u4e00-\u9fa5]/.test(letters[1])
  ) {
    return letters[0];
  } else {
    return letters[0] + letters[1];
  }
}

export function isEmojiReplaceText(text) {
  let regex = /^\[(.{0,30}?_.*?)\]$/;
  return regex.test(text);
}
// 将 html 字符串中的 img 标签用 alt 文字替换
export function replaceImgTagWithAltText(
  str,
  returnType /* html or text */ = "html"
) {
  str = str.replaceAll(/&times/g, "&amp;times");
  let el = document.createElement("div");
  el.innerHTML = str;
  let images = el.querySelectorAll("img");
  Array.prototype.forEach.call(images, function (img) {
    let alt = img.getAttribute("alt");
    if (alt && isEmojiReplaceText(alt)) {
      let altImg = document.createTextNode(alt);
      img.parentNode.replaceChild(altImg, img);
    }
  });

  if (returnType === "html") {
    return el.innerHTML;
  } else if (returnType === "text") {
    return el.innerText;
  }
}
// html 字符串转换成文本
export function innerTextFromHTML(str) {
  let div = document.createElement("div");
  div.innerHTML = str;
  return div.innerText;
}

export function isChineseOrEmoji(char) {
  // 匹配数字、英文字符或特殊字符
  const nonChineseOrEmojiRegex =
    /^[\w\d\s~`!@#$%^&*()_\-+={}\[\]|\\:;"'<>,.?/]+$/;
  if (nonChineseOrEmojiRegex.test(char)) {
    return false;
  }

  // 匹配中文字符
  const chineseRegex =
    /[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\u20000-\u2A6DF\u2A700-\u2B73F\u2B740-\u2B81F\u2B820-\u2CEAF\u2CEB0-\u2EBEF\u30000-\u3134F]/;
  // 匹配 emoji
  const emojiRegex = /\p{Emoji}/u;
  return chineseRegex.test(char) || emojiRegex.test(char);
}

export function addTitleForLinksInHTMLString(htmlString, parsedLinksInfo) {
  if (!parsedLinksInfo) return htmlString;

  let msg = htmlString;
  let div = document.createElement("div");
  div.innerHTML = msg;
  try {
    parsedLinksInfo.forEach((linkInfo) => {
      let { url, title, desc, addition } = linkInfo;
      let original_title = title;
      let aList = div.querySelectorAll(`a[href="${url}"]`);
      Array.prototype.forEach.call(aList, (a) => {
        if (a.getAttribute("href")) {
          if (a.innerText !== url) {
            title = a.innerText
          }
          addition = addition ? JSON.parse(addition) : {};
          if (addition.msg_id) {
            const is_in_room = store.getters.cur_room_data?.room_id == addition.room_id
            // 本房间的消息展示desc(channel_name)，其他房间展示title(room_name)
            if (is_in_room) {
              title = desc
            }
            a.innerHTML = '<i class="iconfont icon-chat-s"></i>' + `来自 ${title} 的消息`
            a.classList.add('is-msg-link')
          } else if (addition.link_id) {
            title = emojiRender.replaceEmojiByTextName(title || '')
            a.innerHTML = '<i class="iconfont icon-post-large"></i>' + title
            a.classList.add('is-msg-link')
            linkInfo.title = title
            linkInfo.desc = emojiRender.replaceEmojiByTextName(desc || '')
          } else if (linkInfo.link_type !== PARSE_LINK_TYPE.invite) {
            a.innerHTML = title
          }
          a.setAttribute("title", original_title)
        }
      });
    });
  } catch {
    return div.innerHTML;
  }
  return div.innerHTML;
}

export function generateRenderText({text, words, row = 1, hasPrefix, fontSize, maxWidth}) {
  if (!text) return ''
  row = row || 1
  fontSize = fontSize || 14
  maxWidth = maxWidth || 265
  text = text.replace(/<br>/g, ' ') // 替换换行符
  const keywords = words.split(/[,， ]+/).filter(keyword => keyword) // 分割关键词，用于高亮
  const maxChars = calcMaxChars(text, hasPrefix, fontSize, maxWidth) * row // 获取最大平均显示字符数

  // 初始化文本截断的起始和结束位置
  let start = 0
  let end = text.length

  // 对文本中的所有关键词进行高亮处理
  const applyHighlight = (text) => {
    return keywords.reduce((acc, keyword) => {
      const regex = new RegExp(keyword, 'gi')
      return acc.replace(regex, `<span highlight-word class="text-bd-tx">${keyword}</span>`)
    }, text)
  }

  // 计算所有关键词在文本中的起始和结束位置
  let positions = keywords.map(keyword => {
    let index = text.indexOf(keyword)
    return { start: index, end: index + keyword.length }
  }).filter(pos => pos.start !== -1)
  // 如果没有找到任何关键词，或文本长度小于最大字符数，直接返回高亮文本
  if (positions.length === 0 || text.length <= maxChars) {
    return applyHighlight(text)
  }

  // 排序关键词位置
  positions.sort((a, b) => a.start - b.start)

  // 如果有多个关键词，尽可能多的显示高亮关键词
  if (positions.length > 1) {
    // 计算关键词的总跨度
    const firstPos = positions[0].start
    const lastPos = positions[positions.length - 1].end
    const keywordsSpan = lastPos - firstPos

    // 如果所有关键词可以放入最大字符数内，则以关键词区间为中心截取
    if (keywordsSpan <= maxChars) {
      start = Math.max(0, firstPos - Math.floor((maxChars - keywordsSpan) / 2))
      end = start + maxChars
      if (end > text.length) {
        end = text.length
        start = Math.max(0, end - maxChars)
      }
    } else { // 如果不可以，则以第一个关键词为中心
      start = Math.max(0, firstPos - Math.floor(maxChars / 2))
      end = start + maxChars
    }
  } else { // 如果只有一个关键词，则以这个关键词为中心
    const singleKeywordPos = positions[0].start
    start = Math.max(0, singleKeywordPos - Math.floor(maxChars / 2))
    end = start + maxChars
  }

  // 根据位置截断文本，添加省略号
  let truncatedText = text.substring(start, end)
  truncatedText = start > 0 ? '...' + truncatedText : truncatedText
  truncatedText = end < text.length ? truncatedText + '...' : truncatedText

  return applyHighlight(truncatedText)
}

export function calcMaxChars(text, hasPrefix, fontSize, maxWidth) {
  const fontSizePx = fontSize;  // 字体大小
  const chineseCharWidth = fontSizePx; // 中文字符和中文标点的平均宽度
  const englishCharWidth = fontSizePx * 0.5; // 英文字符、数字和英文标点的平均宽度
  let maxWidthPx = maxWidth; // 最大宽度，单位px
  if (hasPrefix) {
    maxWidthPx -= 20; // 有前缀时，减去前缀icon的宽度
  }

  // 统计中文字符（包括中文标点）和英文字符（包括数字和英文标点）的数量
  let chineseCharsCount = 0;
  let englishCharsCount = 0;

  for (const char of text) {
    // 中文字符或中文标点的Unicode范围
    if (/[\u4e00-\u9fff\u3000-\u303f\uff00-\uffef]/.test(char)) {
      chineseCharsCount += 1;
    } else {
      englishCharsCount += 1;
    }
  }

  // 计算总宽度
  const totalWidth = (chineseCharsCount * chineseCharWidth) + (englishCharsCount * englishCharWidth);

  // 计算在指定宽度内平均能显示的字符数量
  const averageCharWidth = totalWidth / (chineseCharsCount + englishCharsCount);

  return Math.floor(maxWidthPx / averageCharWidth) - 2;
}